import React from 'react';
import { Box } from '@mui/material';

export function RowIndentation(props: { level: number }) {
  return <Box component="span" sx={{ marginLeft: `${props.level * 24}px` }} />;
}
